var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 -9 58 58"}},[_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"29","cy":"20","r":"29","fill-opacity":".12"}}),_c('path',{attrs:{"fill":"currentColor","fill-rule":"nonzero","d":"M24 1h12v12h12v12H36v12H24V25H12V13h12z"}})])])
}
var staticRenderFns = []

export default { render: render }